module.exports = __webpack_public_path__ + "static/media/bank-raiffeisen.3248bfad.svg";